import { render, staticRenderFns } from "./centerPeopleFlow.vue?vue&type=template&id=e5413c1e"
import script from "./centerPeopleFlow.vue?vue&type=script&lang=js"
export * from "./centerPeopleFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports